import { useNavigate } from 'react-router-dom';

import { Screen } from '~/atomic';
import UpgradePrompt from '~/atomic/molecules/UpgradePrompt/view';
import { useAppDispatch } from '~/store';
import { consumeFeatureUsage } from '~/store/entitlements/thunks';
import { useFeature } from '~/store/entitlements/useFeature';

import CalculatorView from './view';

const FEATURE_SLUG = 'financing_calculator';

export default function AuthenticatedFinanciamentoCalculatorView() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const feature = useFeature(FEATURE_SLUG);
  const blocked =
    feature.isLocked ||
    feature.isExpired ||
    (feature.state === 'freemium' && (feature.quotaRemaining ?? 0) <= 0);

  if (blocked) {
    return (
      <Screen headerTitle="Calculadora de financiamento" hasPadding>
        <div className="mx-auto max-w-[720px] py-large">
          <UpgradePrompt
            entitlement={feature.entitlement}
            featureSlug={FEATURE_SLUG}
            title="Suas simulações gratuitas acabaram"
            description="O plano Free permite duas simulações por conta, sem renovação. Faça upgrade para continuar simulando sem limite."
            ctaText="Ver planos"
            onClickCta={() => navigate('/app/subscribe')}
          />
        </div>
      </Screen>
    );
  }

  const registerSimulation = async () => {
    const result = await dispatch(consumeFeatureUsage(FEATURE_SLUG)).unwrap();
    return result !== null;
  };

  return <CalculatorView onSimulation={registerSimulation} />;
}
